import qs from 'qs';
import { parseCommaSeparatedValues } from './utils/utils';

const {
  REACT_APP_AU_APP_DOMAIN,
  REACT_APP_AWS_DOMAIN,
  REACT_APP_AWS_POOL_ID,
  REACT_APP_AWS_POOL_WEB_CLIENT_ID,
  REACT_APP_AWS_REGION,
  REACT_APP_AWS_USER_POOL_ID,
  REACT_APP_CLIENT,
  REACT_APP_CORE_APP_URL,
  REACT_APP_CORE_AUSTRALIA_URL,
  REACT_APP_CORE_EUROPE_UNION_URL,
  REACT_APP_DOMAIN,
  REACT_APP_ENV = 'development',
  REACT_APP_EU_APP_DOMAIN,
  REACT_APP_GLOBAL_APP_DOMAIN,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_GOOGLE_TAG_MANAGER,
  REACT_APP_HUBSPOT_PORTAL_ID,
  REACT_APP_HUBSPOT_SOCIAL_SIGNUP_FORM_GUID,
  REACT_APP_INCROWD_ANSWERS_URL,
  REACT_APP_LITE_APP_DOMAIN,
  REACT_APP_LITE_APP_URL,
  REACT_APP_NON_CORE_URL,
  REACT_APP_PROTOCOL,
  REACT_APP_RECAPTCHA_FALLBACK_SITE_KEY,
  REACT_APP_RECAPTCHA_SITE_KEY,
  REACT_APP_SSO_FIRST_IDENTITY_PROVIDER,
  REACT_APP_STRIPE_PUBLIC_KEY,
  REACT_APP_TRIAL_APP_URL,
  REACT_TRIAL_DEFAULT_DURATION_IN_DAYS,
  REACT_TRIAL_DEFAULT_RESPONSES,
  REACT_APP_ADMIN_ENABLED_ACCOUNTS,
  REACT_APP_SX_ACCOUNTS
} = process.env;

const trim = (value: string | undefined) => (value || '').trim();
const defaultTrialDurationInDays = (value: string | undefined) => (value || '15').trim();
const defaultTrialResponses = (value: string | undefined) => (value || '30').trim();

export const ENV = trim(REACT_APP_ENV);
export const DOMAIN = trim(REACT_APP_DOMAIN);
export const PROTOCOL = trim(REACT_APP_PROTOCOL);
export const NON_CORE_APP_URL = trim(REACT_APP_NON_CORE_URL);
export const CORE_APP_URL = (trim(REACT_APP_CORE_APP_URL));
/** @deprecated */
export const TRIAL_APP_URL = (trim(REACT_APP_TRIAL_APP_URL));
export const LITE_APP_URL = (trim(REACT_APP_LITE_APP_URL));
export const AWS_POOL_ID = (trim(REACT_APP_AWS_POOL_ID));
export const AWS_REGION = (trim(REACT_APP_AWS_REGION));
export const AWS_USER_POOL_ID = (trim(REACT_APP_AWS_USER_POOL_ID));
export const AWS_POOL_WEB_CLIENT_ID = (trim((REACT_APP_AWS_POOL_WEB_CLIENT_ID || '')).split(','))[0];
export const AWS_DOMAIN = (trim(REACT_APP_AWS_DOMAIN));
export const TRIAL_DEFAULT_DURATION_IN_DAYS = (defaultTrialDurationInDays(REACT_TRIAL_DEFAULT_DURATION_IN_DAYS));
export const TRIAL_DEFAULT_RESPONSES = (defaultTrialResponses(REACT_TRIAL_DEFAULT_RESPONSES));
export const RECAPTCHA_SITE_KEY = (trim(REACT_APP_RECAPTCHA_SITE_KEY));
export const RECAPTCHA_FALLBACK_SITE_KEY = (trim(REACT_APP_RECAPTCHA_FALLBACK_SITE_KEY));
export const REGIONAL_URLS = {
  AUSTRALIA: trim(REACT_APP_CORE_AUSTRALIA_URL),
  EUROPE_UNION: trim(REACT_APP_CORE_EUROPE_UNION_URL)
};
export const GOOGLE_MAPS_API_KEY = trim(REACT_APP_GOOGLE_MAPS_API_KEY);
export const STRIPE_PUBLIC_KEY = trim(REACT_APP_STRIPE_PUBLIC_KEY);
export const CLIENT = (trim(REACT_APP_CLIENT));
export const INCROWD_ANSWERS_URL = (trim(REACT_APP_INCROWD_ANSWERS_URL));
export const GLOBAL_APP_DOMAIN = trim(REACT_APP_GLOBAL_APP_DOMAIN);
export const LITE_APP_DOMAIN = trim(REACT_APP_LITE_APP_DOMAIN);

// use in Features.PlgExternal3
export const AU_APP_DOMAIN = trim(REACT_APP_AU_APP_DOMAIN);
export const EU_APP_DOMAIN = trim(REACT_APP_EU_APP_DOMAIN);
// end of use in Features.PlgExternal3

export const SSO_FIRST_IDENTITY_PROVIDER = trim(REACT_APP_SSO_FIRST_IDENTITY_PROVIDER);

export const GOOGLE_TAG_MANAGER = trim(REACT_APP_GOOGLE_TAG_MANAGER);
export const HUBSPOT_PORTAL_ID = trim(REACT_APP_HUBSPOT_PORTAL_ID);
export const HUBSPOT_SOCIAL_SIGNUP_FORM_GUID = trim(REACT_APP_HUBSPOT_SOCIAL_SIGNUP_FORM_GUID);

const getQueryParmsForAuthURL = (clientId?: string) => {
  // COGNITO SSO FOR INCROWD
  return [
    `redirect_uri=https://app.${DOMAIN}/idpresponse`,
    'response_type=code',
    `client_id=${clientId || AWS_POOL_WEB_CLIENT_ID}`
  ].join('&');
};

export const getAuthorizeUrl = (webClientId?: string | null): string => {
  const queryParamsObj = qs.parse(window.location.search.replace('?', ''));
  const { redirectUrl, sx_client_id, sx_icode, ...restParams } = queryParamsObj;

  const state = Buffer.from(
    JSON.stringify({
      ...restParams,
      sx_client_id: sx_client_id?.toString() || webClientId,
      redirectUrl: redirectUrl?.toString(),
      sx_icode: sx_icode?.toString()
    })
  ).toString('Base64');
  const AWS_AUTHORIZE_URL = `https://${AWS_DOMAIN}/oauth2/authorize?${getQueryParmsForAuthURL(webClientId || sx_client_id?.toString())}`;
  return AWS_AUTHORIZE_URL.concat(`&state=${state}`);
};

export const ADMIN_ENABLED_ACCOUNTS_IDS = new Set<string>(parseCommaSeparatedValues(REACT_APP_ADMIN_ENABLED_ACCOUNTS));
export const SX_ADMIN_ENABLED_ACCOUNTS_IDS = new Set<string>(parseCommaSeparatedValues(REACT_APP_SX_ACCOUNTS));
